import { Component, OnInit, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogRejectReason } from '../../../../base/panel/organizations/models/dialog-reject-reason';

@Component({
  selector: 'app-dialog-decline-sign',
  templateUrl: './dialog-decline-sign.component.html',
  styleUrls: ['./dialog-decline-sign.component.scss']
})
export class DialogDeclineSignComponent implements OnInit {

  closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  cancelSign: EventEmitter<{observations: string, reasonId: number | null}> = new EventEmitter<{observations: string, reasonId: number | null}>();

  declineText: string = '';
  isLoading: boolean = false;
  operationType: string = '';
  rejectionReasons: Array<DialogRejectReason> = [];
  selectedReasonId: number | null = null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.operationType = this.data.operationType;
    this.rejectionReasons = this.data.RejectionReasons || [];
  }

  close(): void {
    this.closeDialog.emit(true);
  }

  cancel(): void {
    this.cancelSign.emit(this.rejectionReasons.length ? {observations: this.declineText, reasonId: this.selectedReasonId} : {observations: this.declineText, reasonId: null});
  }
}